import {
    BriefStore,
    PagePathStore,
    RelatedIndustriesStore,
} from '../../../shared/mixpanel';

const store = {
    pagePath: new PagePathStore(),
    brief: new BriefStore(),
    relatedIndustries: new RelatedIndustriesStore({
        disableErrorLogging: true,
    }),
};

export default store;
